/**
 * Named Tailwind class-string constants, one per pre-Tailwind CSS selector they
 * replace. Colors/fonts come from the tailwind.config.js tokens.
 */

// dashboard.css -> .negative-cell
// Used by: PortfolioOptimizerTable, PositionDetailsTable,
// pos_sizing_table/PositionSizingTable,
// watchlist_table/WatchlistTable
export const negativeCell = 'text-negative';

// OptimizedColumn.css -> .optimized-column
// Used by: PositionDetailsTable (DataGrid cellClassName)
export const optimizedColumn = '!bg-optimized';

// OptimizedColumn.css -> .ai-column
// Used by: PositionDetailsTable (DataGrid cellClassName)
export const aiColumn = '!bg-ai';

// dashboard.css -> .card, reworked flat (no gradients/shadows) for the
// cold/hard financial-terminal brief. Used by most dashboard panels/tables.
export const cardClasses =
  'app-card relative rounded-[2px] border border-hairline bg-surface p-4 min-h-full';

// AISelector.css -> .ai-selector-label
// Used by: AISelector.jsx
export const aiSelectorLabel = 'text-[14px] font-[550] text-black';

// AISelector.css -> .ai-selector-section
// Used by: AISelector.jsx
export const aiSelectorSection =
  'bg-white px-[10px] min-w-[300px] flex items-center justify-between rounded-[5px] border border-selector-border';

// login.css -> .login-root
// Used by: Login.jsx
export const loginRoot = 'min-h-screen font-roboto-mono';

// login.css -> .login-container
// Used by: Login.jsx
export const loginContainer = 'min-h-screen w-full';

// login.css -> .login-left-section
// Used by: Login.jsx
export const loginLeftSection = 'pt-[72px] px-[clamp(28px,3vw,72px)] pb-[32px] flex flex-col justify-start';

// login.css -> .login-right-section
// bg image is set via inline style in Login.jsx — arbitrary bg-[url(...)] doesn't resolve relative asset paths through PostCSS.
// Used by: Login.jsx
export const loginRightSection =
  'flex-1 relative overflow-hidden flex bg-center bg-no-repeat [background-size:auto_100%]';

// login.css -> .login-text-container
// Used by: Login.jsx
export const loginTextContainer =
  'relative flex flex-col justify-center items-start text-white font-roboto-mono' +
  ' py-[1.25rem] pr-[2.2rem] pl-[3rem]' +
  ' bg-[linear-gradient(90deg,rgba(2,6,23,0.65)_0%,rgba(2,6,23,0.28)_65%,rgba(2,6,23,0)_100%)]' +
  ' rounded-r-2xl';

// login.css -> .label-username
// Used by: Login.jsx (LableLoginPage)
export const labelUsername = 'font-semibold text-[16px] font-roboto-mono block mb-2';

// login.css -> .login-form
// Used by: Login.jsx
export const loginForm = 'flex flex-col gap-[15px]';

// login.css -> .forgt-password-box-container
// Used by: Login.jsx
export const forgtPasswordBoxContainer =
  'flex justify-between items-center font-roboto-mono text-[12px] mt-2 text-login-link font-semibold';

// login.css -> .forget-password / .forget-password:hover
// Used by: Login.jsx
export const forgetPassword =
  'no-underline text-login-link font-semibold text-[12px] cursor-pointer hover:text-login-link-hover';
